import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

/** This Class helps parsing "opinionated" strings like '10001_25000', '1000000_' or '_10000' into numbers.
 * It provides a "from" and a "to" values, which can also be null. */
var NumberRangeParser = /*#__PURE__*/function () {
  function NumberRangeParser(rangeString) {
    var _this = this;

    _classCallCheck(this, NumberRangeParser);

    _defineProperty(this, "getFrom", function () {
      if (_this.rangeSplit[0] !== '' && _this.rangeSplit[1] === '' || _this.doBothValuesHaveNumber()) {
        return _parseInt(_this.rangeSplit[0], 0);
      }

      return null;
    });

    _defineProperty(this, "getTo", function () {
      if (_this.rangeSplit[0] === '' && _this.rangeSplit[1] !== '' || _this.doBothValuesHaveNumber()) {
        return _parseInt(_this.rangeSplit[1], 0);
      }

      return null;
    });

    _defineProperty(this, "doBothValuesHaveNumber", function () {
      return _this.rangeSplit[0] !== '' && _this.rangeSplit[1] !== '';
    });

    this.rangeSplit = rangeString.split('_');
  }
  /* --- "PRIVATE" METHODS (as if JS could have something Private.....) ---*/
  // In the case of '10001_25000', it returns 10001, in case of '_10000' it returns null,
  // in case of '1000000_' it returns 1000000


  _createClass(NumberRangeParser, [{
    key: "from",
    get:
    /* --- "PUBLIC" METHODS ---*/
    function get() {
      return this.getFrom();
    }
  }, {
    key: "to",
    get: function get() {
      return this.getTo();
    }
  }]);

  return NumberRangeParser;
}();

export default NumberRangeParser;